/**
 * Központi szövegek az alkalmazáshoz.
 *
 * A termékek ezt a fájlt vagy az egyes namespace-eket módosíthatják
 * a saját nyelvükre/szövegeikre.
 *
 * Struktúra:
 * - common: Közös szövegek (gombok, általános UI)
 * - components: Közös komponensek szövegei (ErrorBoundary, accessibility)
 * - errors: API és rendszer hibaüzenetek
 * - validation: Validációs hibaüzenetek
 * - registration: Regisztráció feature
 * - login: Bejelentkezés feature
 * - forgotPassword: Elfelejtett jelszó feature
 * - resetPassword: Jelszó visszaállítás feature
 * - pages: Általános oldalak (home, 404)
 *
 * Használat:
 * ```tsx
 * import { messages } from "@/shared/i18n";
 *
 * <p>{messages.common.loading}</p>
 * <p>{messages.registration.form.emailLabel}</p>
 * <p>{messages.errors.network}</p>
 * ```
 *
 * i18n könyvtár integrálásakor (pl. react-i18next):
 * - Minden namespace külön JSON fájllá alakítható
 * - A struktúra kompatibilis a legtöbb i18n megoldással
 */

import {
  common,
  components,
  errors,
  forgotPassword,
  home,
  login,
  pages,
  registration,
  resetPassword,
  validation,
  verifyEmail,
} from "./namespaces";

export const messages = {
  // Közös
  common,
  components,
  errors,
  validation,

  // Features
  registration,
  login,
  forgotPassword,
  resetPassword,
  verifyEmail,
  home,

  // Oldalak
  pages,
} as const;

/**
 * Típus a messages objektumhoz
 */
export type Messages = typeof messages;
